// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"HelpMailModalOrder_confirmModal__L4_8I","confirmationButtonsBox":"HelpMailModalOrder_confirmationButtonsBox__dB4DR","error":"HelpMailModalOrder_error__zLPux"};